import { clsx } from 'clsx'

import { Space, SpaceMembershipStatus } from '@tribeplatform/gql-client/types'

import { SpaceLeaveButton } from '../../Space/SpaceLeaveButton.js'
import { SpaceMembershipButton } from '../../Space/SpaceMembershipButton.js'
import { StaticField } from '../../Views/types.js'

interface Props {
  field: StaticField
  space: Space
  highlighted: boolean
  stretchX: string
}
export const JoinButton = ({ field, space, highlighted, stretchX }: Props) => {
  const joined =
    space?.authMemberProps?.membershipStatus === SpaceMembershipStatus.joined

  return (
    <>
      <div
        className={clsx(
          'flex space-s-2 text-content-subdued items-center empty:hidden',
          highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
          stretchX,
        )}
        onClick={e => e.stopPropagation()}
      >
        {joined ? (
          <SpaceLeaveButton
            space={space}
            size={field.settings?.buttonSize ?? 'lg'}
            fullWidth
          />
        ) : (
          <SpaceMembershipButton
            space={space}
            size={field.settings?.buttonSize ?? 'lg'}
            fullWidth
          />
        )}
      </div>
    </>
  )
}
